import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { FDBodyText } from '@facet-wealth/design';
import { SelectInputSmall } from 'Packages/FacetDesign/Components';
import { monthYear } from 'Consts/DateFormats';
import DateOrYearPickerLeftLabelPlacement from 'Components/ComponentLibrary/Molecules/dateOrYearPicker/leftLabelPlacement';
import OriginalValueLayout from './LeverLayouts/originalValueLayout';

export const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('label', {
    _component: FDBodyText,
  }, overrideReadOnly)
  .nameOverride(['value', 'amount', 'when', 'who', 'start', 'stop', 'startType', 'startDate', 'startAtAge', 'endType', 'endDate', 'endAtAge'], {
    _customProps: {
      labelPlacement: 'left',
      required: false, // hide asterisks
    },
  }, overrideReadOnly)
  .override({ name: 'value', hint: 'yearMonth' }, { // need to specify both hint and value to override the default 'value' meta override
    _customProps: {
      labelPlacement: 'left',
      required: false, // hide asterisks
      inputFormat: monthYear,
    },
  }, overrideReadOnly)
  .override({ name: 'start', hint: 'yearMonth' }, { // need to specify both hint and value to override the default 'value' meta override
    _customProps: {
      labelPlacement: 'left',
      required: false, // hide asterisks
      inputFormat: monthYear,
    },
  }, overrideReadOnly)
  .override({ name: 'startDate', hint: 'yearMonth' }, { // need to specify both hint and value to override the default 'value' meta override
    _customProps: {
      labelPlacement: 'left',
      required: false, // hide asterisks
      inputFormat: monthYear,
    },
  }, overrideReadOnly)
  .override({ name: 'stop', hint: 'yearMonth' }, { // need to specify both hint and value to override the default 'value' meta override
    _customProps: {
      labelPlacement: 'left',
      required: false, // hide asterisks
      inputFormat: monthYear,
    },
  }, overrideReadOnly)
  .override({ name: 'endDate', hint: 'yearMonth' }, { // need to specify both hint and value to override the default 'value' meta override
    _customProps: {
      labelPlacement: 'left',
      required: false, // hide asterisks
      inputFormat: monthYear,
    },
  }, overrideReadOnly)
  .override({ name: 'when', hint: 'yearMonth' }, { // need to specify both hint and value to override the default 'value' meta override
    _customProps: {
      labelPlacement: 'left',
      required: false, // hide asterisks
      inputFormat: monthYear,
    },
  }, overrideReadOnly)
  .nameOverride('plannedRetirementDate', {
    _component: () => DateOrYearPickerLeftLabelPlacement,
    _customProps: {
      labelPlacement: 'left',
      inputFormat: monthYear,
      startDateField: 'dateOfBirth',
      isAge: true,
    },
  }, overrideReadOnly)
  .typeOverride('picklist', {
    _customProps: {
      labelPlacement: 'left',
      fullWidth: true,
      required: false, // hide asterisks
    },
    _component: () => SelectInputSmall,
  }, overrideReadOnly)
  .nameOverride(['originalValue'], { // must be the last to override all other overrides
    _component: () => OriginalValueLayout,
  }, overrideReadOnly);
